import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../../user/selectors'
import { getPcrIdSelector } from '../../../home/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { MotorVehicleIncidentConstants } from '../store/motorVehicleIncident.constants'

export function* clearMotorVehicleIncident() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const pcrDocUpdated = { ...pcrDoc }
      if (
        pcrDocUpdated &&
        pcrDocUpdated.ccHpiMotorVehicleIncident &&
        Object.keys(pcrDocUpdated.ccHpiMotorVehicleIncident).length
      ) {
        delete pcrDocUpdated.ccHpiMotorVehicleIncident
      }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`clearMotorVehicleIncident() error: ${e}`))
    }
  } else {
    yield put(throwPcrException('pcrID not found'))
  }
}

export function* clearMotorVehicleIncidentSaga() {
  yield takeLatest(
    [MotorVehicleIncidentConstants.CLEAR_MOTOR_VEHICLE_INCIDENT],
    performWithMutexHOG,
    clearMotorVehicleIncident
  )
}
